import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function Index() { 
    const [ appointments, setAppointments ] = useState([]);

    useEffect(() => { 
        axios.get('http://localhost:5000/Appointments/AllAppointments')
            .then((response) => { 
                setAppointments(response.data);
            })
            .catch((error) => { 
                console.log(error);
            })
    }) 

    useEffect(() => { 
        axios.get('http://localhost:5000/Appointments/AllAppointments')
            .then((response) => { 
                setAppointments(response.data);
            })
            .catch((error) => { 
                console.log(error);
            })
    }, [appointments]);


    return(
        <React.Fragment>
            <h1>Appointments</h1>
            <Link to="/Admin/Appointments/Create" className="btn btn-secondary">Create</Link>
            <table className="table table-sm table-bordered table-bordered">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>User</th>
                        <th>Location</th>
                        <th>Doctor</th>
                        <th>Update</th>
                        <th>Details</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        [...Array((appointments.length))].map((e, i) => 
                            <tr key={i}>
                                <td>{appointments[i]._id}</td>
                                <td>{appointments[i].userId}</td>
                                <td>{appointments[i].department}</td>
                                <td>{appointments[i].doctor}</td>
                                <td><Link to={"/Admin/Appointments/Update/" + appointments[i]._id}>Update</Link></td>
                                <td><Link to={"/Admin/Appointments/Details/" + appointments[i]._id}>Details</Link></td>
                                <td><Link to={"/Admin/Appointments/Delete/" + appointments[i]._id}>Delete</Link></td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </React.Fragment>
    )
    
}